export const IconArrowUpLongThin: {
  name: 'icon_arrow_up_long_thin-4a854880d7c4'
} = {
  name: 'icon_arrow_up_long_thin-4a854880d7c4'
}
